// src/components/inputs/MultiImageUploader/UploadDropZone.jsx

import React from "react";
import { Paper, Typography } from "@mui/material";
import { CloudUpload } from "@mui/icons-material";

const UploadDropZone = ({
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject,
    isArabic,
    disabled,
    maxImages,
    maxSizeMB,
    isDark,
    open,
}) => {
    return (
        <Paper
            {...getRootProps()}
            sx={{
                p: 3,
                mb: 2,
                border: '2px dashed',
                borderColor: isDragReject
                    ? 'error.main'
                    : isDragActive
                        ? 'primary.light'
                        : 'primary.main',
                backgroundColor: isDragActive
                    ? (isDark ? 'rgba(25, 118, 210, 0.15)' : 'rgba(25, 118, 210, 0.08)')
                    : isDragReject
                        ? (isDark ? 'rgba(244, 67, 54, 0.15)' : 'rgba(244, 67, 54, 0.08)')
                        : (isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.01)'),
                cursor: disabled ? 'not-allowed' : 'pointer',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                transform: isDragActive ? 'scale(1.02)' : 'scale(1)',
                '&:hover': {
                    backgroundColor: disabled
                        ? undefined
                        : (isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)'),
                    borderColor: disabled ? undefined : 'primary.light',
                },
            }}
            onClick={open}
        >
            <input {...getInputProps()} />

            <CloudUpload
                sx={{
                    fontSize: 48,
                    color: isDragReject
                        ? 'error.main'
                        : isDragActive
                            ? 'primary.light'
                            : 'primary.main',
                    mb: 1,
                    transition: 'all 0.3s ease',
                }}
            />

            <Typography variant="body1" sx={{ mb: 0.5, fontWeight: isDragActive ? 600 : 400 }}>
                {isDragReject
                    ? (isArabic ? 'نوع الملف غير مدعوم' : 'File type not supported')
                    : isDragActive
                        ? (isArabic ? 'أسقط الصور هنا' : 'Drop images here')
                        : (isArabic
                            ? 'اسحب وأسقط الصور هنا أو انقر للاختيار'
                            : 'Drag & drop images here or click to select'
                        )
                }
            </Typography>

            <Typography variant="caption" color="text.secondary">
                {isArabic
                    ? `الحد الأقصى ${maxImages} صور، كل صورة بحد أقصى ${maxSizeMB} ميجابايت`
                    : `Max ${maxImages} images, ${maxSizeMB}MB each`}
            </Typography>
        </Paper>
    );
};

export default UploadDropZone;
